import React from "react"
const isIncrease = true

export default class Slider extends React.Component {
  constructor (props) {
    super(props)

    this.handleChange = this.handleChange.bind(this)
    this.handleClick = this.handleClick.bind(this)

    this.state = {
      width: 0
    }
  }

  componentDidMount () {
    let { showProgress } = this.props
    let width = document.getElementById('satisfecho').offsetWidth
    if (showProgress) {
      this.setState({ width })
    }
  }
  handleChange (e) {
    let obj = {}
    let val = parseFloat(e.target.value)
    let { onChange } = this.props
    obj[e.target.id] = val
    onChange( val, obj )
  }
  handleClick (isPlus) {
    let { disabled, max, min, step, value, onChange } = this.props

    if (disabled) {
      return
    }

    // Fix the decimal of value as the step's
    let numArr = step.toString().split(".")
    let decimal = 0

    if (numArr.length === 2) {
      decimal = numArr[1].length
    }

    let tmp = isPlus
      ? (value + step).toFixed(decimal)
      : (value - step).toFixed(decimal)
    if (isPlus) {
      value = parseFloat(tmp) > max ? max : parseFloat(tmp)
    } else {
      value = parseFloat(tmp) < min ? min : parseFloat(tmp)
    }

    onChange(value)
  }
  render () {
    let {
      id,
      className,
      disabled,
      max,
      min,
      step,
      value,
      showProgress,
      onPlus,
      onMinus
    } = this.props
    let { width } = this.state
    let prgs = ((value - min) / (max - min)) * width
    let prgsBar = showProgress ? (
      <div className="progress" style={{ width: `${prgs}px` }} />
    ) : (
      ''
    )
    // if(value == 0) {
    //   className = `${className} cero` 
    // } else {
    //   className =  className.replace('cero', '')
    // }
    return (
      <div className={`c-flex aic c-slider ${className}`}>
        <i
          className="fa fa-search-minus c-link"
          aria-hidden="true"
          onClick={onMinus || this.handleClick.bind(this, !isIncrease)}
        />
        <div className="c-flex aic">
          <input
            type="range"
            id={id}
            ref={ref => {
              this.input = ref
            }}
            disabled={disabled}
            max={max}
            min={min}
            step={step}
            value={value}
            onChange={disabled ? null : this.handleChange}
          />
        </div>
        <i
          className="fa fa-search-plus c-link"
          aria-hidden="true"
          onClick={onPlus || this.handleClick.bind(this, isIncrease)}
        />
      </div>
    )
  }
}
Slider.propTypes = {
  id: React.PropTypes.string,
  className: React.PropTypes.string,
  disabled: React.PropTypes.bool,
  max: React.PropTypes.number,
  min: React.PropTypes.number,
  step: React.PropTypes.number,
  value: React.PropTypes.number,
  showProgress: React.PropTypes.bool,
  onChange: React.PropTypes.func,
  onMinus: React.PropTypes.func,
  onPlus: React.PropTypes.func
}


// WEBPACK FOOTER //
// ./src/components/Patient/Component/Slider.js